/* tslint:disable:no-console */
import $axios from "axios";
import { v4 } from "uuid";
const { VUE_APP_API_URL } = process.env;
console.log(VUE_APP_API_URL);
import { getInstance } from "../auth";

const $HTTP = $axios.create({ baseURL: VUE_APP_API_URL });

$HTTP.interceptors.request.use(async config => {
  const authService = getInstance();
  const requestId = v4();
  config.headers["request-id"] = requestId;
  config.headers.Accept = "application/json, text/plain, */*";
  config.headers["Content-Type"] = "application/json";
  if (!authService || !authService.isAuthenticated) {
    return config;
  }

  console.log(config.headers.Authorization);

  try {
    const token = await authService.getTokenSilently();
    config.headers.Authorization = `Bearer ${token}`;
    // console.log(config.headers.Authorization);
    return config;
  } catch (e) {
    return this.$router.push("/");
  }
});

$HTTP.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const errorMessage = error.message;
    const substring = "401";
    const errorCheck = errorMessage.includes(substring);

    return new Promise((resolve, reject) => {
      if (errorCheck) {
        const authService = getInstance();
        authService.logOut();
        console.warn(errorMessage);
      } else {
        console.error(error);
        reject(error);
      }
    });
  }
);

export default $HTTP;
